import { z } from 'zod';

// ─── Filter type enum (includes LIST for null/empty type) ───────────────────

export const ReportBudgetFilterTypeEnum = z.enum(['LIST', 'FACE', 'BODY-FRONT', 'BODY-BACK', 'TEETH']);
export type ReportBudgetFilterType = z.infer<typeof ReportBudgetFilterTypeEnum>;

// ─── Query schema (validated from req.query) ─────────────────────────────────

export const ReportBudgetQuerySchema = z.object({
	patient_id: z.coerce.number().int().positive().optional(),
	patient_name: z.string().optional(),
	responsible_name: z.string().optional(),
	user_id: z.coerce.number().int().positive().optional(),
	budget_type: ReportBudgetFilterTypeEnum.optional(),
	start_date: z.string().optional(),
	end_date: z.string().optional(),
	page: z.coerce.number().int().positive().default(1),
	limit: z.coerce.number().int().positive().default(50),
	report: z.string().optional(),
});
export type ReportBudgetQuery = z.infer<typeof ReportBudgetQuerySchema>;

// ─── Response item ────────────────────────────────────────────────────────────

export const ReportBudgetItemSchema = z.object({
	id: z.number(),
	source: z.enum(['HOF', 'BUDGET_V2']),
	type: z.string().nullable(),
	created_at: z.date(),
	patient_id: z.number().nullable(),
	patient_name: z.string().nullable(),
	patient_cellphone: z.string().nullable(),
	user_name: z.string().nullable(),
	responsible_name: z.string().nullable(),
	total_price: z.number(),
	total_approved: z.number(),
	total_rejected: z.number(),
	total_value_done: z.number(),
	total_not_done: z.number(),
});
export type ReportBudgetItem = z.infer<typeof ReportBudgetItemSchema>;

// ─── Response ─────────────────────────────────────────────────────────────────

export const ReportBudgetResponseSchema = z.object({
	status: z.literal('success'),
	data: z.array(ReportBudgetItemSchema),
	pages: z.number(),
	totalRecords: z.number(),
	total: z.number(),
	total_approved: z.number(),
	total_rejected: z.number(),
	total_value_done: z.number(),
	total_not_done: z.number(),
});
export type ReportBudgetResponse = z.infer<typeof ReportBudgetResponseSchema>;
